import React, { useContext, useEffect, useState } from "react";
import "./Step_3.css";
import Summery_holder from "../summery_holder/Summery_holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import Cart_details_card from "../../common_components/cart_details_card/Cart_details_card";
import Purple_border_btn from "../../common_components/common_btn/purple_border_btn/Purple_border_btn";
import Purple_Btn from "../../common_components/common_btn/purple_btn/Purple_Btn";
import { Badge, Table } from "react-bootstrap";
import Logo_modal from "../../common_components/logo_modal/Logo_modal";
import { Context } from "../../../utils/context";
import Summery_holder_order from "../summery_holder/Summery_holder_order";
import { getAllPricesLuxury } from "../../../utils/luxuryapis/addToCart/addToCart";
import {
  postorderCOD,
  postorderOnline,
} from "../../../utils/luxuryapis/orderProcess/orderProcess";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { PointSetup } from "../../../utils/apis/master/Master";
function Step_3({
  setActiveStep,
  goBackToPayment,
  cartData,
  paymentMethod,
  billingAddrress,
  shippingAddrress,
  user,
  giftData,
}) {
  const { IMG_URL, signin } = useContext(Context);
  const [modalShow, setModalShow] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [loder, setLoder] = React.useState(false);
  const [rewardStatus, setRewardStatus] = useState(false);
  const [allPrice, setAllprice] = useState();
  const AllPriceGet = async () => {
    const res = await getAllPricesLuxury(giftData, rewardStatus);
    if (res?.success) {
      setAllprice(res?.data);
      // finalFunction();
    } else {
      console.error("Error fetching data:", res?.error);
    }
  };
  useEffect(() => {
    AllPriceGet();
  }, [paymentMethod, rewardStatus]);

  const nevigate = useNavigate();

  const finalFunction = async (razor = null) => {
    setLoder(true);
    const data = {
      shipping_address_id: shippingAddrress?.id,
      billing_address_id: billingAddrress?.id,
      to: giftData?.to,
      from: giftData?.from,
      message: giftData?.message,
      gift_status: true,
      gift_details: giftData?.gifts,
      // gift_price_total: totalGiftInduasalPrice,
      payment_mode: paymentMethod,
      totalCalculation: allPrice.totalCalculations,

      singleEntityCalculations: allPrice.singleEntityCalculations,
    };

    if (razor) {
      data.payment_id = razor;
    }
    const res = await postorderCOD(data);
    if (res?.success) {
      setLoder(false);
      nevigate("/luxury/payment-success");
      // setModalShow(true);
      // setTimeout(() => {
      //   // setModalShow(false);
      //   nevigate("/luxury/payment-success");
      // }, 3000);
    } else {
      setLoder(false);
      setError(res?.message);
    }
  };

  const finalFunctionOnline = async (razor = null) => {
    setLoder(true);
    const data = {
      shipping_address_id: shippingAddrress?.id,
      billing_address_id: billingAddrress?.id,
      to: giftData?.to,
      from: giftData?.from,
      message: giftData?.message,
      gift_status: true,
      gift_details: giftData?.gifts,
      // gift_price_total: totalGiftInduasalPrice,
      payment_mode: paymentMethod,
      totalCalculation: allPrice.totalCalculations,

      singleEntityCalculations: allPrice.singleEntityCalculations,
    };

    if (razor) {
      data.payment_id = razor;
    }
    const res = await postorderOnline(data);
    if (res?.success) {
      if (res?.data?.actionUrl && res?.data?.paymentData) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = res.data.actionUrl;

        const paymentData = res.data.paymentData;

        Object.keys(paymentData).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = paymentData[key];
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      }
      // setLoder(false);
      // setModalShow(true);
      // setTimeout(() => {
      //   setModalShow(false);
      //   nevigate("/luxury/home");
      // }, 3000);
    } else {
      setLoder(false);
      setError(res?.message);
    }
  };

  const [pointSetup, setPointSetup] = useState();
  const getPointsetup = async () => {
    const res = await PointSetup();
    if (res?.success) {
      setPointSetup(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getPointsetup();
  }, []);
  return (
    <>
      <section className="cart_step_content Step_3">
        <div className="row">
          {/* LEFT CONTENT */}
          <div className="col-md-8">
            {/* ACCOUNT */}
            <div className="content_box_holder mt-3">
              <div className="heading_strip_holder">
                <h1>Account</h1>
                <hr />
              </div>

              <div className="content_strip_holder account_strip">
                <p>{user?.email}</p>
                {/* <FontAwesomeIcon icon={faPenToSquare} /> */}
              </div>
            </div>

            {/* PAYMENT / ORDER INFO */}
            <div className="content_box_holder mt-3">
              <div className="heading_strip_holder">
                <h1>Payment</h1>
                <hr />
              </div>

              {/* ORDER TABLE */}
              <div className="table_holder mt-3">
                <div className="table-responsive">
                  <Table className=" order_table">
                    <thead>
                      <tr>
                        {/* <th>Order Number</th> */}
                        <th>Status</th>
                        <th>Date</th>
                        <th>Total</th>
                        <th>Payment method</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {/* <td>0005-12122025</td> */}
                        <td>Ordered</td>
                        <td>
                          {new Date()
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                            .toUpperCase()}
                        </td>
                        <td>₹ {allPrice?.totalCalculations?.totalAmount}</td>
                        <td>{paymentMethod}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>

              <hr />

              {/* ORDER DETAILS */}
              <h4 className="section_title">Order Details</h4>

              <div className="order_details_holder">
                {cartData?.data?.map((val) => (
                  <Cart_details_card data={val} IMG_URL={IMG_URL} />
                ))}
              </div>

              {/* PRICE SUMMARY */}
              <div className="total_price_row">
                <p>Subtotal</p>
                <p>₹ {Number(allPrice?.totalCalculations?.totalSellingPrice).toFixed(2)}</p>
              </div>
              <hr />
              <div className="table_holder mt-3">
                <div className="table-responsive">
                  <Table className=" order_table">
                    <tbody>
                      <tr>
                        <th>Gift Wrap Price</th>
                        <td>₹ {Number(allPrice?.totalCalculations?.totalGiftPrice).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <th>Customise Price</th>
                        <td>
                          ₹ {Number(allPrice?.totalCalculations?.totalCustomizePrice).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <th>Delivery Charges</th>
                        <td>
                          ₹ {Number(allPrice?.totalCalculations?.totalDileveryCharges).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <th>Total Tax</th>
                        <td>₹ {Number(allPrice?.totalCalculations?.totalTax).toFixed(2)}</td>
                      </tr>

                      <tr>
                        <th>Payment Method</th>
                        <td>{paymentMethod}</td>
                        <td></td>
                      </tr>

                      <tr>
                        <th>
                          <div>
                            Point Discount <br />{" "}
                            <span
                              style={{ color: "orangered", fontSize: "15px" }}
                            >
                              (
                              {((user?.point || 0) *
                                (pointSetup?.coin_percentage || 0)) /
                                100}{" "}
                              Redeemable points )
                            </span>{" "}
                            <br />{" "}
                            {Number(user?.point) > 0 && (
                              <Badge
                                className={
                                  rewardStatus ? "bg-success" : "bg-secondary"
                                }
                                style={{
                                  cursor: "pointer",
                                  opacity: rewardStatus ? 0.6 : 1,
                                }}
                                onClick={() => setRewardStatus(!rewardStatus)}
                              >
                                {rewardStatus ? "Applied" : "Apply"}
                              </Badge>
                            )}
                          </div>
                        </th>
                        <td>
                          <b>₹ {allPrice?.totalCalculations?.point_discount}</b>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
              <hr />

              <div className="total_price_row">
                <p>Total</p>
                <p>₹ {Number(allPrice?.totalCalculations?.totalAmount).toFixed(2)}</p>
              </div>

              <div className="earn_coins_holder">
                <h4 className="earn_coins">
                  You will earn {allPrice?.totalCalculations?.coin} coins
                </h4>

                {/* ADDRESSES */}
                <div className="row ">
                  <div className="col-md-6">
                    <div className="address_holder">
                      <h5>Billing Address</h5>
                      <hr />
                      <p>
                        {billingAddrress?.location}, {billingAddrress?.company},{" "}
                        {billingAddrress?.address},{" "}
                        {billingAddrress?.city?.name},{" "}
                        {billingAddrress?.state?.name},{" "}
                        {billingAddrress?.country?.name} -{" "}
                        {billingAddrress?.pincode?.name}
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="address_holder">
                      <h5>Shipping Address</h5>
                      <hr />
                      <p>
                        {shippingAddrress?.location},{" "}
                        {shippingAddrress?.company}, {shippingAddrress?.address}
                        ,{shippingAddrress?.city?.name},{" "}
                        {shippingAddrress?.state?.name},{" "}
                        {shippingAddrress?.country?.name} -{" "}
                        {shippingAddrress?.pincode?.name}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {error && (
                <span style={{ color: "red", fontSize: "14px" }}>{error}</span>
              )}
              <div className="btn_holder">
                <div>
                  <Purple_border_btn btnText="Back" onClick={goBackToPayment} />
                </div>

                {loder ? (
                  <div>
                    <ClipLoader />
                  </div>
                ) : (
                  <div>
                    {paymentMethod === "COD" ? (
                      <Purple_Btn
                        btnText="Place Order"
                        onClick={() => {
                          finalFunction();
                        }}
                      />
                    ) : (
                      <Purple_Btn
                        btnText="Place Order"
                        onClick={() => {
                          finalFunctionOnline();
                        }}
                      />
                    )}
                  </div>
                )}
              </div>

              <div className="forgot_text">
                <p>
                  Forgot an Item?{" "}
                  <span
                    onClick={() => {
                      setActiveStep(1);
                    }}
                  >
                    Edit Your Cart
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SUMMARY */}
          <div className="col-md-4">
            <Summery_holder_order allPrice={allPrice} />
          </div>
        </div>
      </section>

      <Logo_modal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}

export default Step_3;
